import request from '@/utils/request';

export function listPerformance(query) {
  return request({
    url: '/front/performance/list',
    method: 'get',
    params: query,
    silent: true
  });
}

export function getFeaturedPerformances(limit = 6) {
  return request({
    url: '/front/performance/featured',
    method: 'get',
    params: { limit },
    silent: true
  });
}

export function getPerformance(id) {
  return request({
    url: '/front/performance/' + id,
    method: 'get',
    silent: true
  });
}
